<template>
	<div>
		<list-page-gen :options="options" />
	</div>
</template>

<script>
import ListPageGen from './ListPageGen.vue'

const config = {
	options: {
		resource: 'forms',
		display: [
			{ key: 'clientId' },
			{ key: 'tag' },
			{ key: 'translations' },
			{ key: 'fields' },
			{ key: 'createdAt' }
		],
		comparisonDisplay: ['clientId', 'tag'],
		postThenPatch: true,
		modifier: async data =>
			data.map(r => {
				const translations = r.translations.map(t => ({
					[t.locale]: t.value
				}))
				const fields = r.fields.map(t => t.id)
				return Object.assign({}, r, { translations, fields })
			}),
		filterModifier: async data => {
			data.client = Object.assign({}, data.id)
			data.client.properties.id.title = 'Client'
			data.autocompleteFields = [
				{
					name: 'client.id', // name of the field in jsonschema eg. data.client.properties.id = client.id
					resource: 'clients',
					query: 'id',
					display: 'id' // field from response to be displayed in the suggestion
				}
			]
			delete data.id
			return data
		}
	}
}

export default {
	name: 'FormsList',
	components: { ListPageGen },
	data: () => config
}
</script>
